<template>

    <div v-if="features.showBettingLogos && showOnCurrentPage" class="flex">
       <img src="../assets/images/logos/gambling/gamcare-white_285x100 (4).png" />
        <a href="https://www.gamstop.co.uk/" target="_blank" rel="noopener noreferrer"> <img src="../assets/images/logos/gambling/gamstop-white.png" /></a>
        <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer"> <img src="../assets/images/logos/gambling/GambleAware_white_250x100 (1).png" /></a>
        <a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer"> <img src="https://cdn.rewards4sport.com/cdn-cgi/image/width=285,format=auto,quality=90,fit=scale-down/https://images.rewards4sport.com/rewards4sport/gamcare-white.png" /></a>
        <a href="https://gordonmoody.org.uk/" target="_blank" rel="noopener noreferrer"> <img src="https://cdn.rewards4sport.com/cdn-cgi/image/width=250,format=auto,quality=90,fit=scale-down/https://images.rewards4sport.com/rewards4sport/GordonMoody_Icononly_250x100.png" /></a>
        <a href="https://www.raig.org/news-press/press-pr-page/responsible-affiliates-in-gambling-introduces-social-responsibility-audit/" target="_blank" rel="noopener noreferrer"> <img src="../assets/images/logos/gambling/raig.png" /></a>

    

     
    </div>

</template>


<script lang="ts">
        import { defineComponent, computed } from "vue";
        import { useRoute } from "vue-router";
        import { useTenantConfig } from "../composables/useTenantConfig";

        const BETTING_PATH_KEYWORDS = [
            "betting",
            "bet365",
            "betfred",
            "betfair",
            "paddy-power",
            "safer-gambling",
            "help-centre/advice",
            "help-centre/stay-in-control",
            "help-centre/gambling-harm",
        ];

        export default defineComponent({
            name: "gamble",
            setup() {
                const { branding, features } = useTenantConfig();
                const route = useRoute();

                const showOnCurrentPage = computed(() => {
                    const path = route.path.toLowerCase();
                    return BETTING_PATH_KEYWORDS.some((keyword) =>
                        path.includes(keyword)
                    );
                });

                return {
                    branding,
                    features,
                    showOnCurrentPage,
                };
            },
        });
</script>

<style scoped>
    .flex {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
    }

        .flex img {
            max-height: 50px;
        }
</style>